import { Highlight, themes } from "prism-react-renderer";
import type { FilterConfiguration } from "~/components/assistant/types";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "~/components/ui/accordion";
import usePrismLanguages from "~/hooks/usePrismLanguages";

interface FilterMessageProps {
  filters: FilterConfiguration;
}

/**
 * Renders filter configuration from the filter builder agent.
 * Collapsed by default since this is primarily for debugging purposes.
 */
export function FilterMessage({ filters }: FilterMessageProps) {
  const { Prism } = usePrismLanguages(["json"]);
  const code = JSON.stringify(filters, null, 2);

  return (
    <div
      className="border border-gray-200 rounded-lg w-full"
      aria-label="Filter configuration display"
    >
      <Accordion type="single" collapsible>
        <AccordionItem value="filter-config" className="border-b-0">
          <AccordionTrigger className="px-4 py-2">
            <span className="text-sm font-medium text-gray-700">Filter Configuration</span>
          </AccordionTrigger>
          <AccordionContent className="px-4">
            <Highlight theme={themes.vsLight} code={code} language="json" prism={Prism}>
              {({ style, tokens, getLineProps, getTokenProps }) => (
                <pre
                  className="text-xs font-mono p-3 rounded overflow-x-auto whitespace-pre-wrap"
                  style={style}
                >
                  {tokens.map((line, i) => (
                    <div key={i} {...getLineProps({ line })}>
                      {line.map((token, key) => (
                        <span key={key} {...getTokenProps({ token })} />
                      ))}
                    </div>
                  ))}
                </pre>
              )}
            </Highlight>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
}
